import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import camelize from 'camelize';
import { urls } from 'app-constants';
import renderBlockErrors from './renderBlockErrors';
import Select from 'components/common/Select';
import FormGroup from './FormGroup';


const Preset = ({
  uid,
  errors,
  preset,
  onPreviewTextUpdate,
  onChange,
}) => {
  const [presetOptions, setPresetOptions] = useState(null);

  const presetSelectVal = (presetOptions || []).find(opt => opt.value === preset);
  const handlePresetChange = val => onChange({ preset: val });

  const fetchPresets = () => {
    fetch(urls.contentPresetChoices, { credentials: 'include' })
      .then(response => {
        if (!response.ok) throw new Error(response.statusText);
        return response;
      })
      .then(response => response.json())
      .then(data => camelize(data))
      .then(data => {
        setPresetOptions(data.map(({ uuid, name }) => ({ value: uuid, label: name })));
      })
      .catch(err => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchPresets();
  }, []);

  useEffect(() => {
    onPreviewTextUpdate(presetSelectVal ? presetSelectVal.label : '');
  }, [presetSelectVal]);

  const renderedErrors = renderBlockErrors(errors);

  return (
    <div className="content">
      <FormGroup label="Preset:">
        <Select
          value={presetSelectVal}
          options={presetOptions || []}
          disabled={presetOptions === null}
          onChange={handlePresetChange}
        />
        {renderedErrors.preset}
      </FormGroup>
      <FormGroup>
        <div className="form-input-hint m-0">
          <a href={urls.contentPresetManage} target="_blank" rel="noopener noreferrer">manage presets</a>
        </div>
      </FormGroup>
    </div>
  );
};

Preset.propTypes = {
  uid: PropTypes.string,
  errors: PropTypes.object,
  preset: PropTypes.string,
  onPreviewTextUpdate: PropTypes.func,
  onChange: PropTypes.func,
};

export default Preset;
